// extracted by mini-css-extract-plugin
module.exports = {"userLinkContainer":"AccountIcon_userLinkContainer__0DfrL","accessibilityButton":"AccountIcon_accessibilityButton__A8_kB"};